import { Button, Modal } from "antd";

const LinkPagoModal = (props) => {
    const { verLinkPagoModal, setVerLinkPagoModal, linkPago, error } = props;

    return (
        <Modal 
            open={verLinkPagoModal} 
            title={<><h3 style={{ fontSize: '1.5vw', margin: 0 }}>{error ? "Error" : "Proceso de pago"}</h3></>} 
            closeIcon={<></>}
            height={"75%"}
            width={{
                xs: "90%",
                sm: "80%",
                md: "70%",
                lg: "60%",
                xl: "50%"
            }}
            footer={<></>}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                {error ? 
                    <p>Ha ocurrido un error al generar su link de pago.</p> 
                :
                    <iframe
                        title="Link de Pago"
                        src={linkPago}
                        style={{ width: '100%', height: 650, border: 'none' }}
                        scrolling="no"
                        onLoad={(e) => {
                            try {
                                console.log("iframe cargado, intentando obtener URL actual...");
                                const iframeUrl = e.target.contentWindow.location.href;
                                console.log("URL actual del iframe:", iframeUrl);
                            } catch(error) {
                                console.log("error al obtener redireccion")
                            }
                        }}
                    />
                }
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <Button onClick={() => setVerLinkPagoModal(false)} type="primary" size="large">
                    {error ? "Cerrar" : "Volver"}
                </Button>
            </div>
        </Modal>
    )
};

export default LinkPagoModal;